/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AdminContributedOffer = {
    snapId?: number;
    collectorId: string;
    milesAmount?: number;
    status: AdminContributedOffer.status;
    createdAt?: string;
};

export namespace AdminContributedOffer {

    export enum status {
        CONTRIBUTED = 'CONTRIBUTED',
        ISSUED = 'ISSUED',
    }


}

